/**
 * The console's first screen, decided by the organization's standard (ADR 0095).
 *
 * Under `flowza_sign` it is the dashboard it has always been. Under `international` it is My
 * Documents — the workspace-shaped home the founder photographed on 2026-09-13, where the list of
 * documents IS the landing page. Both are the same route, so a bookmark of `/app` and the
 * sidebar's first entry keep working whichever way an administrator sets the standard.
 *
 * The International home is its own chunk. The dashboard stays eager (routes/index.tsx says why),
 * and the international one cannot be without dragging the library, its folder tree and its actions
 * into the entry chunk every surface downloads — so it costs one fetch, covered by a loading state
 * that names what it is loading.
 *
 * `GetStarted` rides here too: the first-upload dialog belongs to the first screen and not to the
 * shell, because a person who lands on Settings from a link did not come to upload anything.
 */
import { lazy, Suspense } from 'react'
import { LoadingState } from '@flowza/ui'
import { apiConfigured } from '../../api/client'
import { useWorkflow } from '../../auth/workflow'
import Dashboard from './Dashboard'

const MyDocumentsHome = lazy(() => import('./MyDocumentsHome'))
const GetStarted = lazy(() => import('./GetStarted'))

export default function Home() {
  const { profile } = useWorkflow()
  return (
    <>
      {profile.workflow_standard === 'international' ? (
        <Suspense fallback={<LoadingState label="Loading your documents" />}>
          <MyDocumentsHome />
        </Suspense>
      ) : (
        <Dashboard />
      )}
      {apiConfigured() ? (
        <Suspense fallback={null}>
          <GetStarted />
        </Suspense>
      ) : null}
    </>
  )
}
